<!--
  @Author 22030124/xieyq
  @Date 2023-12-28 11:22:26
  @Description 用户选择弹窗
-->
<template>
  <cosmo-select-user-dialog
    :class="scope.clsPrefix"
    ref="selectDialog"
    :multiple="multiple"
    :tagLabel="label"
    :valueKey="valueKey"
    :is-inner="isInner"
    :normalizer="normalizer"
    :disabled-keys="disabledKeys"
    :currentUserEmpsn="currentUserEmpsn"
    @onClose="close"
    @submit="submit"
  >
  </cosmo-select-user-dialog>
</template>

<script>
// 用户选择弹层
import CosmoSelectUserDialog from './dialog.vue'
// 公共混入js
import CommonMixins from './common.js'
export default {
  // 组件名称
  name: 'CosmoUserDialogSelect',
  components: {
    CosmoSelectUserDialog
  },
  mixins: [CommonMixins],
  // 参数
  props: {
    // 是否可见
    visible: Boolean
  },
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'cosmo-user-dialog-select'
      }
    }
  },
  // 监听
  watch: {
    // 监听是否可见
    visible(val) {
      val && this.open()
    }
  },
  // 创建完成
  created() {},
  // 挂载完成
  mounted() {},
  // 方法
  methods: {

    // 打开
    open() {
      // 显示弹层
      this.$refs.selectDialog && this.$refs.selectDialog.initDialog(this.value)
    },

    /**
     * 关闭
     * @returns {void}
     */
    close() {
      this.$emit('close')
      // 隐藏弹窗
      this.$emit('update:visible', false)
    },

    /**
     * 弹窗确定事件
     * @param {Object} selectedRows 选中的人员信息
     * @returns {void}
     */
    submit(selectedRows) {
      // 获取结果值
      const result = this.getResult(selectedRows)
      // 抛出select方法
      this.$emit('select', result)
      // 调用关闭
      this.close()
    }
  }
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: 'cosmo-user-dialog-select';
.#{$class-prefix} {
}
</style>
